export default __webpack_public_path__ + "static/media/copper.9b90cd93.jpg";